import { ChangeDetectorRef, Directive, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewRef, inject } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { TimeoutService } from '@df/ng/timeout.service';
import { WishlistItem } from '@df/session/api/wishlist/wishlist-item';
import { Customer } from '@df/session/customer/customer.interfaces';
import { Subscription } from 'rxjs';
import { Wishlist } from '../api/wishlist/wishlist';

@Directive()
export abstract class WishlistToggleComponentDef implements OnInit, OnChanges, OnDestroy {
    /**
     * Product id
     */
    @Input()
    productId?: number;

    /**
     * Item id
     */
    @Input()
    item?: WishlistItem;

    /**
     * Retrieve status model for request processing info
     * @type {object}
     */
    status = new Status();

    toggle: () => void;
    protected subscription = new Subscription();

    protected app = inject(App);
    protected timeoutService = inject(TimeoutService);
    wishlist = inject(Wishlist);

    constructor(protected _ref: ChangeDetectorRef) {
        this.toggle = this.timeoutService.throttle(() => this._toggle(), 300);
        this._ref.detach();
    }

    ngOnInit() {
        this.subscription.add(this.wishlist.subscribe(() => this.detectChanges()));
        this.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.detectChanges();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * Checks if item is in wishlist already
     */
    get inWishlist(): boolean {
        return !!this.item || (this.productId ? (this.wishlist.getItemsByProduct(this.productId)?.length || 0) > 0 : false);
    }

    /**
     * Toggle item being in wishlist
     */
    protected _toggle(): Promise<Customer.ILoadResponse> | void {
        return this.wishlist.toggle(this.status, (this.item || this.productId)!);
    }

    removeItem() {
        this.wishlist.remove(this.status, this.item!.data.id);
    }

    protected detectChanges() {
        this.timeoutService.async(() => {
            if (!(<ViewRef>this._ref).destroyed) {
                this._ref.detectChanges();
            }
        });
    }
}
